.shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--color-bg);
}

.skipLink {
  position: absolute;
  top: var(--space-2);
  left: var(--space-2);
  z-index: calc(var(--z-header) + 1);
  padding: var(--space-2) var(--space-4);
  border-radius: var(--radius-md);
  background: var(--color-interactive);
  color: var(--color-text-on-color);
  font-weight: var(--weight-semibold);
  text-decoration: none;
  transform: translateY(-200%);
}

.skipLink:focus-visible {
  transform: none;
  color: var(--color-text-on-color);
}

/* Верхняя панель (DESIGN.md 1.5): логотип над меню, «клиника · роль», справа «Помощь», уведомления, Рус/Қаз, аватар. */
.topBar {
  position: sticky;
  top: 0;
  z-index: var(--z-header);
  display: flex;
  align-items: center;
  gap: var(--space-2);
  height: var(--size-header);
  padding: 0 var(--space-6) 0 0;
  border-bottom: 1px solid var(--color-border-subtle);
  background: var(--color-header);
}

/* Бэк-офис — тёмная панель с чипом «Бэк-офис», чтобы команда не путала его с кабинетом клиники. */
.topBarBackoffice {
  border-bottom-color: transparent;
  background: var(--color-header-backoffice);
  color: var(--color-header-backoffice-text);
  --color-text-primary: var(--color-header-backoffice-text);
  --color-text-secondary: var(--color-header-backoffice-muted);
  --color-text-helper: var(--color-header-backoffice-muted);
  --color-icon-primary: var(--color-header-backoffice-text);
  --color-icon-secondary: var(--color-header-backoffice-muted);
  --color-layer-hover: var(--color-header-backoffice-hover);
  --color-layer-hover-strong: var(--color-header-backoffice-hover);
  --color-layer-1: var(--color-header-backoffice-hover);
  --color-nav-selected: var(--color-header-backoffice-hover);
  --color-avatar-bg: var(--color-header-backoffice-hover);
  --color-avatar-text: var(--color-header-backoffice-text);
  --color-focus: var(--color-header-backoffice-text);
}

.topBarGroup {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  min-width: 0;
}

.brandGroup {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-shrink: 0;
  width: var(--size-sidenav);
  padding-inline-start: var(--space-6);
}

.topBarSpacer {
  flex: 1 1 auto;
}

.clinicSlot {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}

/* Чип «Демо» (DESIGN.md 1.8): вместо баннеров «Демо-данные» и пометок «Песочница» на страницах. */
.demoChip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 var(--space-2);
  border-radius: var(--radius-sm);
  background: var(--color-selected);
  color: var(--color-text-secondary);
  font-size: var(--type-caption-size);
  white-space: nowrap;
}

.demoShort {
  display: none;
}

/* Телефон: чип остаётся (бриф: «Демо» на всех страницах), подпись короче; диктор читает полную. */
@media (max-width: 720px) {
  .demoFull {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }

  .demoShort {
    display: inline;
  }
}

.menuButton {
  display: none;
}

/* Логотип: Literata только здесь (DESIGN.md 1.3). */
.logo {
  display: inline-flex;
  align-items: baseline;
  gap: 1px;
  flex-shrink: 0;
  padding: var(--space-1) 0;
  border-radius: var(--radius-sm);
  color: var(--color-text-primary);
  font-family: var(--font-logo);
  font-size: 1.375rem;
  line-height: 1.5rem;
  font-weight: var(--weight-semibold);
  letter-spacing: -0.03em;
  text-decoration: none;
}

.logo:hover {
  color: var(--color-text-primary);
}

.logoTld {
  font-family: var(--font-sans);
  font-size: 0.75rem;
  letter-spacing: 0;
  color: var(--color-link);
}

.topBarBackoffice .logoTld {
  color: var(--color-header-backoffice-muted);
}

.areaLabel {
  padding: 3px var(--space-2);
  border-radius: var(--radius-sm);
  background: var(--color-header-backoffice-hover);
  color: var(--color-header-backoffice-text);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
  font-weight: var(--weight-semibold);
  white-space: nowrap;
}

/* «Демо-клиника · Врач» — одной строкой, без рамки. */
.clinicButton {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  max-width: 420px;
  min-height: var(--size-control-md);
  padding: 0 var(--space-2) 0 10px;
  border: 0;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-text-primary);
  font-size: var(--type-body-sm-size);
  text-align: start;
}

.clinicButton:hover {
  background: var(--color-layer-hover);
}

.clinicButton svg {
  flex-shrink: 0;
  fill: var(--color-icon-secondary);
}

.clinicText {
  display: flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
}

.clinicName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: var(--weight-semibold);
}

.clinicRoles {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-text-helper);
}

.clinicRoles::before {
  content: '·';
  margin-inline-end: 6px;
}

.clinicStatic {
  border-color: transparent;
  cursor: default;
}

.clinicStatic:hover {
  background: transparent;
}

.language {
  display: inline-flex;
  gap: 2px;
}

.languageButton {
  min-width: 36px;
  min-height: 30px;
  padding: 0 var(--space-2);
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--color-text-helper);
  font-size: 0.8125rem;
}

.languageButton:hover {
  background: var(--color-layer-hover);
  color: var(--color-text-primary);
}

.languageButton[aria-pressed='true'] {
  background: var(--color-layer-1);
  color: var(--color-text-primary);
  font-weight: var(--weight-semibold);
}

/* Профиль — только инициалы; имя, телефон и роль — в открытом меню. */
.profileButton {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-height: var(--size-control-md);
  padding: 0 2px;
  border: 0;
  border-radius: var(--radius-pill);
  background: transparent;
  color: var(--color-text-primary);
}

.profileButton:hover {
  background: var(--color-layer-hover);
}

.profileName {
  display: none;
}

.profileHeader {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.profileHeaderName {
  font-weight: var(--weight-semibold);
  overflow-wrap: anywhere;
}

.profileHeaderMeta {
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
}

.helpButton {
  color: var(--color-text-secondary);
  font-weight: var(--weight-regular);
}

.helpButton:hover {
  color: var(--color-text-primary);
}

.helpButtonIcon {
  display: none;
  fill: currentColor;
}

.helpButtonLabel {
  display: inline;
}

.body {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.sideNav {
  position: sticky;
  top: var(--size-header);
  flex-shrink: 0;
  width: var(--size-sidenav);
  height: calc(100vh - var(--size-header));
  overflow-y: auto;
  border-inline-end: 1px solid var(--color-border-subtle);
  background: var(--color-nav);
}

/* Меню (DESIGN.md 1.5): белое, пункты 36 px без иконок, группы подписаны мелким серым, активный — bg.subtle и 600. */
.navInner {
  display: flex;
  flex-direction: column;
  padding: var(--space-4) var(--space-3) var(--space-6);
}

.navGroup + .navGroup {
  margin-top: var(--space-5);
}

.navGroupTitle {
  padding: 0 var(--space-3) 6px;
  color: var(--color-text-helper);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
  font-weight: var(--weight-regular);
}

.navList {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.navLink {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  min-height: var(--size-nav-item);
  padding: 0 var(--space-3);
  border-radius: var(--radius-md);
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
  text-decoration: none;
}

.navLink:hover {
  background: var(--color-layer-hover);
  color: var(--color-text-primary);
}

.navLink[aria-current='page'] {
  background: var(--color-nav-selected);
  color: var(--color-text-primary);
  font-weight: var(--weight-semibold);
}

.navLink:focus-visible {
  outline-offset: -2px;
}

/* Счётчик пункта меню: число цветом смысла, без плашки. */
.navCount {
  flex-shrink: 0;
  font-size: var(--type-caption-size);
  font-weight: var(--weight-semibold);
  font-variant-numeric: tabular-nums;
  color: var(--color-text-helper);
}

.navCountAccent {
  color: var(--color-link);
}

.navCountDanger {
  color: var(--color-error);
  font-weight: var(--weight-bold);
}

/* Вкладки группы разделов над экраном: текст с подчёркиванием активной, линия line снизу. */
.sectionTabs {
  margin-bottom: var(--space-6);
  border-bottom: 1px solid var(--color-border-subtle);
}

.sectionTabsList {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-6);
}

.sectionTab {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  margin-bottom: -1px;
  border-bottom: 2px solid transparent;
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  text-decoration: none;
}

.sectionTab:hover {
  color: var(--color-text-primary);
}

.sectionTab[aria-current='page'] {
  border-bottom-color: var(--color-text-primary);
  color: var(--color-text-primary);
  font-weight: var(--weight-semibold);
}

.sectionTab:focus-visible {
  outline-offset: 2px;
}

.navEmpty {
  padding: var(--space-3);
  color: var(--color-text-helper);
  font-size: var(--type-body-sm-size);
}

.main {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  outline: none;
}

.content {
  width: 100%;
  max-width: var(--size-content-max);
  margin: 0 auto;
  padding: var(--space-7) var(--size-page-gutter) var(--space-12);
}

.offlineBanner {
  position: sticky;
  top: var(--size-header);
  z-index: var(--z-sticky);
}

.fullPageStatus {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: var(--space-6);
}

.public {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--color-bg);
}

.publicHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  height: var(--size-header);
  padding: 0 var(--space-4);
}

.publicMain {
  display: flex;
  flex: 1 1 auto;
  align-items: flex-start;
  justify-content: center;
  padding: var(--space-8) var(--space-4) var(--space-12);
  outline: none;
}

.authCard {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  width: min(460px, 100%);
  padding: var(--space-8);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-lg);
  background: var(--color-bg);
}

.authIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-lg);
  background: var(--color-layer-1);
}

.authIcon svg {
  fill: var(--color-text-primary);
}

.authHeading {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.authTitle {
  font-size: var(--type-page-title-size);
  line-height: var(--type-page-title-line);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-title);
}

.authText {
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.authForm {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.authFooter {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--space-2);
  padding-top: var(--space-4);
  border-top: 1px solid var(--color-border-subtle);
}

.notificationList {
  display: flex;
  flex-direction: column;
}

.notificationItem {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr);
  gap: var(--space-3);
  width: 100%;
  padding: var(--space-3) var(--space-4);
  border: 0;
  border-bottom: 1px solid var(--color-border-subtle);
  background: transparent;
  color: var(--color-text-primary);
  text-align: start;
  text-decoration: none;
}

.notificationItem:hover {
  background: var(--color-layer-hover);
  color: var(--color-text-primary);
}

.notificationItem:focus-visible {
  outline-offset: -2px;
}

.unreadDot {
  width: 8px;
  height: 8px;
  margin-top: 6px;
  border-radius: 50%;
  background: var(--color-interactive);
}

.readDot {
  background: transparent;
}

.notificationBody {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.notificationTitle {
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
  font-weight: var(--weight-semibold);
}

.notificationText {
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.notificationTime {
  color: var(--color-text-helper);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

.popoverPad {
  padding: var(--space-4);
}

.notificationFooter {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
}

.helpForm {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.helpIntro {
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.helpContext {
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  background: var(--color-layer-1);
  font-size: var(--type-body-sm-size);
}

.helpContext summary {
  cursor: pointer;
  color: var(--color-link);
}

.helpContext dl {
  margin-top: var(--space-2);
}

.recordingBar {
  flex-shrink: 1;
  min-width: 0;
}

@media (max-width: 1055px) {
  .menuButton {
    display: inline-flex;
  }

  .brandGroup {
    width: auto;
    padding-inline-start: var(--space-2);
  }

  .topBar {
    padding-inline-end: var(--space-3);
  }

  .content {
    padding: var(--space-5) var(--space-5) var(--space-10);
  }
}

@media (max-width: 671px) {
  .topBar {
    gap: 0;
    padding: 0 var(--space-1) 0 0;
  }

  .topBarGroup {
    gap: var(--space-1);
  }

  .brandGroup {
    gap: var(--space-1);
    padding-inline-start: var(--space-1);
  }

  .clinicRoles,
  .profileName,
  .helpButtonLabel,
  .areaLabel {
    display: none;
  }

  .helpButtonIcon {
    display: inline;
  }

  .languageButton {
    min-width: 36px;
  }

  /* На телефоне переключатель клиники — отдельной строкой во всю ширину: название клиники всегда видно (ПОРТ-16). */
  .topBar {
    flex-wrap: wrap;
    height: auto;
    min-height: var(--size-header);
    padding-block: 6px;
  }

  .clinicSlot {
    order: 10;
    flex: 1 0 100%;
    padding-top: var(--space-1);
  }

  .clinicButton {
    width: 100%;
    max-width: none;
  }

  .offlineBanner {
    position: static;
  }

  .authCard {
    padding: var(--space-6) var(--space-4);
  }
}

.skeletonTitle {
  margin-bottom: var(--space-6);
}

/* Сенсорные экраны: элементы верхней панели не меньше 44 px по высоте (DESIGN.md → Accessibility). */
@media (pointer: coarse) {
  .languageButton {
    min-height: 44px;
  }

  .language {
    padding: 0;
  }

  .logo {
    padding-block: 10px;
  }
}
